import { Badge, BadgeProps } from "@mantine/core";
import { IconSchoolFilled, IconUserFilled } from "@tabler/icons-react";

export const getAttendanceColor = (value: number | null | undefined): string | undefined => {
    if (value === null || value === undefined) {
        return 'gray';
    }
    if (value >= 0.9) {
        return 'green';
    }
    if (value >= 0.85) {
        return 'orange';
    }
    return 'red';
};

export function renderAttendance(value: number | null | undefined, decimalsPlaces: number = 2): string {
    if (value === null || value === undefined) {
        return '-';
    }
    if (value === 1) {
        return '100%';
    }
    const percentage = value * 100;
    return `${percentage.toFixed(decimalsPlaces)}%`;
}

type AttendanceBadgeProps = {
    attendance: number;
    decimalsPlaces?: number;
    attendanceType?: 'overall' | 'class'
} & BadgeProps;

export const AttendanceBadge: React.FC<AttendanceBadgeProps> = ({ attendance, decimalsPlaces = 2, attendanceType, ...badgeProps }) => {

    return (
        <Badge 
            fw={400} 
            styles={{
                root: {
                    paddingLeft: 6,
                    paddingRight: 6,
                    width: 'fit-content',
                    minWidth: 'max-content',
                    flexShrink: 0,
                },
                label: {
                    overflow: 'visible',
                    textOverflow: 'clip',
                    whiteSpace: 'nowrap',
                },
            }} 
            variant={'filled'} 
            color={getAttendanceColor(attendance)} 
            leftSection={attendanceType === 'class' ? <IconSchoolFilled size={13} /> : attendanceType === 'overall' ? <IconUserFilled size={11} /> : undefined}
            px={attendanceType ? 4 : undefined}
            {...badgeProps}
        >
            {renderAttendance(attendance, decimalsPlaces)}
        </Badge>
    )
}
